import { render, staticRenderFns } from "./ProvinciasNewOrEdit.vue?vue&type=template&id=49a451e6&scoped=true&"
import script from "./ProvinciasNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./ProvinciasNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProvinciasNewOrEdit.vue?vue&type=style&index=0&id=49a451e6&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a451e6",
  null
  
)

export default component.exports